import apiClient from "../../services/apiClient";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookies";

const DASHBOARD_BASE_URL = "https://api.learning2earning.net";

export default function Dashboard() {
  const navigate = useNavigate();
  const [isDashboardData, setDashboardData] = useState();
  const [newsData, setNewsData] = useState(null);
  const [afterLoginPopupUrl, setAfterLoginPopupUrl] = useState(null);

  useEffect(() => {
    fetchDashboardData();
    fetchDashboardNews();
    fetchAfterLoginPopup();
  }, []);

  const fetchAfterLoginPopup = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");
      const res = await apiClient.post("/App/GetPopupAfterLogin", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1 && res.popup) {
        const popupUrl = encodeURI(`${DASHBOARD_BASE_URL}/${res.popup}`);
        const img = new Image();
        img.onload = () => setAfterLoginPopupUrl(popupUrl);
        img.onerror = () => setAfterLoginPopupUrl(null);
        img.src = popupUrl;
      } else {
        setAfterLoginPopupUrl(null);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchDashboardNews = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");
      const res = await apiClient.post("/App/GetAppNews", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        version: "1.0",
        isLoginNews: false,
        ID: 0,
        IsB2C: false,
        TID: 0,
      });

      if (res.statuscode == 1) {
        setNewsData(res.newsContent);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const fetchDashboardData = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/Dashboard/MataMaskDashboard", {
        appid: "ROUNDPAYAPPID13APR20191351",
        imei: "d593bdd26dfbea56",
        loginTypeID: 1,
        regKey: "",
        serialNo: "d593bdd26dfbea56",
        session: getCookie("session") || "",
        sessionID: getCookie("sessionID") || "",
        userID: userData.userID || "",
        version: "1.0",
      });

      if (res.statuscode == 1) {
        setDashboardData(res);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  function formatAmount(amount) {
    const num = Number(amount) || 0;
    return `₹${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const dashboardData = isDashboardData?.data;
  const isActive = dashboardData?.isTopup === true;
  const profileDetails = dashboardData?.profileDetails;

  return (
    <>
      {afterLoginPopupUrl && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(6,8,12,0.72)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 16,
          }}
          onClick={() => setAfterLoginPopupUrl(null)}
        >
          <div
            style={{ position: "relative", maxWidth: 480, width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <span
              onClick={() => setAfterLoginPopupUrl(null)}
              style={{
                position: "absolute",
                top: -14,
                right: -14,
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#fff",
                color: "#111",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
              }}
            >
              &times;
            </span>
            <img
              src={afterLoginPopupUrl}
              alt="Announcement"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 14,
                display: "block",
                boxShadow: "0 40px 100px -30px rgba(0,0,0,0.7)",
              }}
            />
          </div>
        </div>
      )}
      <div className="content">
        <section className="page active" id="page-dashboard">
          {newsData?.newsDetail && (
            <div className="news-marquee">
              <div className="news-marquee-label">Latest News</div>
              <div className="news-marquee-body">
                <div className="news-marquee-track">
                  <span
                    dangerouslySetInnerHTML={{ __html: newsData.newsDetail }}
                  />
                  <span
                    dangerouslySetInnerHTML={{ __html: newsData.newsDetail }}
                  />
                </div>
              </div>
            </div>
          )}

          <div
            className={`banner ${isActive ? "unlocked" : "locked"}`}
            id="dashBanner"
          >
            <div className="banner-text">
              {isActive ? (
                <>
                  <h2>Your account is active 🎉</h2>
                  <p>
                    You now have full access to courses, live sessions.
                  </p>
                </>
              ) : (
                <>
                  <h2>Your account isn't active yet</h2>
                  <p>
                    Activate your package to unlock recorded courses, live
                    mentorship sessions, your wallets, and team reports.
                  </p>
                  <button
                    className="btn-primary"
                    onClick={() => navigate("/panel/activate_package")}
                  >
                    Activate Package →
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="grid grid-4" style={{ marginBottom: 20 }}>
            <div
              className="card stat-card"
              style={{
                padding: "14px 16px",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div
                className="avatar"
                style={{ width: 38, height: 38, fontSize: 14, flexShrink: 0 }}
              >
                {profileDetails?.userProfilePic ? (
                  <img
                    src={
                      profileDetails.userProfilePic.startsWith("http")
                        ? profileDetails.userProfilePic
                        : `${DASHBOARD_BASE_URL}${profileDetails.userProfilePic.startsWith("/") ? "" : "/"}${profileDetails.userProfilePic}`
                    }
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <svg viewBox="0 0 24 24" fill="currentColor" width="60%" height="60%">
                    <circle cx={12} cy={8} r={4} />
                    <path d="M4 20a8 8 0 0116 0z" />
                  </svg>
                )}
              </div>
              <div>
                <div style={{ fontSize: 12.5, fontWeight: 700 }}>
                  {profileDetails?.name || "-"}
                </div>

                <div className="stat-value" style={{ fontSize: 14 }}>
                  {profileDetails?.userID || "-"}
                </div>
              </div>
            </div>
            <div className="card stat-card" style={{ padding: "14px 16px" }}>
              <div className="stat-label">Mobile No.</div>
              <div className="stat-value" style={{ fontSize: 14 }}>
                {profileDetails?.mobileNo || "-"}
              </div>
            </div>
            <div className="card stat-card" style={{ padding: "14px 16px" }}>
              <div className="stat-label">Mail ID</div>
              <div className="stat-value" style={{ fontSize: 13 }}>
                {profileDetails?.emailID || "-"}
              </div>
            </div>
            <div className="card stat-card" style={{ padding: "14px 16px" }}>
              <div className="stat-label">Activation PKG</div>
              <div className="stat-value" style={{ fontSize: 14 }}>
                {profileDetails?.lastTopupName} (
                {profileDetails?.lastTopupAmount})
              </div>
            </div>
          </div>
          <h3 className="section-title">Your Snapshot</h3>
          <div className="grid grid-6">
            <div className="card stat-card" id="statCourse">
              <div className="stat-label">Course Progress</div>
              <div className="stat-value">
                {dashboardData?.courseProgress ?? 0}%
              </div>

              <div
                className="lock-overlay"
                data-overlay=""
                style={{ display: "none" }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <rect x={4} y={10} width={16} height={10} rx={2} />
                  <path d="M8 10V7a4 4 0 018 0v3" />
                </svg>
                Activate to unlock
              </div>
            </div>
            <div className="card stat-card" id="statLive">
              <div className="stat-label">Materials Completed</div>
              <div className="stat-value">
                {dashboardData?.materialsCompleted ?? 0}
              </div>
              <div
                className="lock-overlay"
                data-overlay=""
                style={{ display: "none" }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <rect x={4} y={10} width={16} height={10} rx={2} />
                  <path d="M8 10V7a4 4 0 018 0v3" />
                </svg>
                Activate to unlock
              </div>
            </div>
          </div>
          <h3 className="section-title">Quick Actions</h3>
          <div className="grid grid-3">
            <div
              className="card quick-action"
              onClick={() => navigate("/panel/courses")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                cursor: "pointer",
              }}
            >
              <div
                className="icon-circle"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: "var(--bg-elev-2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--gold)"
                  strokeWidth="1.8"
                >
                  <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "13.5px" }}>
                  Continue Learning
                </div>
                <div style={{ fontSize: 12, color: "var(--text-faint)" }}>
                  Pick up your last video
                </div>
              </div>
            </div>

            <div
              className="card quick-action"
              onClick={() => navigate("/panel/wallets")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                cursor: "pointer",
              }}
            >
              <div
                className="icon-circle"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: "var(--bg-elev-2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--gold-bright)"
                  strokeWidth="1.8"
                >
                  <rect x={2} y={6} width={20} height={14} rx="2.5" />
                  <path d="M2 10h20" />
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "13.5px" }}>
                  Transfer Wallet Funds
                </div>
                <div style={{ fontSize: 12, color: "var(--text-faint)" }}>
                  Move to withdrawal wallet
                </div>
              </div>
            </div>
            <div
              className="card quick-action"
              onClick={() => navigate("/panel/complain_list")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 14,
                cursor: "pointer",
              }}
            >
              <div
                className="icon-circle"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: "var(--bg-elev-2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--green)"
                  strokeWidth="1.8"
                >
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                  <path d="M14 2v6h6" />
                  <path d="M9 15h6M9 11h2" />
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "13.5px" }}>
                  Complaints
                </div>
                <div style={{ fontSize: 12, color: "var(--text-faint)" }}>
                  Tell us about your issue &amp; we're here to help.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
